import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute } from '@nuxtjs/composition-api'
import { IMPACT_CARRY_CONCEPT_ID } from '~/constants/concepts'
import { type ImpactType, useGetImpactQuery } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'MetricAssignmentsTable',
  props: {
    impactId: { default: undefined },
    impactData: { default: undefined },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { impactId: number, impactData: Record<string, any>, disabled: boolean };



const route = useRoute()
const ventureId = computed(() => route.params.venture)
const impactId = computed(() => props.impactId)
const hasImpactId = computed(() => typeof impactId.value === 'number')
const metricAssignmentFilters = computed(() => ({
  assigneeIds: [ventureId.value],
  impactIds: hasImpactId.value ? [impactId.value as number] : [],
}))

const {
  result: impactResult,
  refetch: refetchImpact,
} = useGetImpactQuery(
  computed(() => ({ impactId: impactId.value })),
  computed(() => ({ enabled: !!props.impactId })),
)

const impact = computed(
  () => (impactResult.value?.getImpact || props.impactData) as ImpactType | undefined,
)

const isImpactCarry = computed(
  () => impact.value?.conceptId === IMPACT_CARRY_CONCEPT_ID,
)

const tableHeaders = computed(() => {
  const headers = ['expandToggle', 'metric.name']
  if (isImpactCarry.value) headers.push('customTargetWeight')
  headers.push('unitName', 'comment')
  if (!props.disabled) headers.push('action')
  return headers
})

const impactCarryReferencePeriods = computed<number[] | null>(() => {
  if (!isImpactCarry.value) return null
  const start = impact.value?.startingYear ?? null
  const duration = impact.value?.durationYears ?? 5
  if (!start || duration <= 0) return null
  return Array.from({ length: duration }, (_, i) => start + i)
})

const handleMetricValuesUpdated = () => {
  refetchImpact()
}

return { __sfc: true,props, route, ventureId, impactId, hasImpactId, metricAssignmentFilters, impactResult, refetchImpact, impact, isImpactCarry, tableHeaders, impactCarryReferencePeriods, handleMetricValuesUpdated }
}

})